/* eslint-disable @typescript-eslint/no-explicit-any */
import { useNavigate } from "react-router";
import Breadcrumbs from "../../../components/breadcrumbs/Breadcrumbs";
import GridTable from "../../../components/GridTable/GridTable";
import { DynamicFilterConfig } from "../../../components/DynamicComponent/DynamicFilterPanel";
import endpoints from "../../../services/endpoints";
import { formatDateToDDMMYYYY } from "../../../components/commonfunctions/convertDate";

export default function ListOfJournalVoucher() {
  const navigate = useNavigate();
  const { journalVoucher } = endpoints;

  // Get client timezone
  const clientTimezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  const TableDetails: { [key: string]: any } = {
    "Transaction ID": {
      id: "transaction_id",
    },
    "Date and Time": {
      id: "date_time",
      custom: ["date_time"],
    },
    "Description": {
      id: "description",
      className: "min-w-[450px]",
    },
    "Account": {
      id: "account_name",
      className: "min-w-[400px]",
    },
    "Debit": {
      id: "debit",
      custom: ["debit"],
    },
    "Credit": {
      id: "credit",
      custom: ["credit"],
    },
  };

  const staticText = {
    emptyScreenText: {
      heading1: "No Data",
      heading2: "No records found.",
    },
  };

  const dynamicFilterConfig: DynamicFilterConfig = {
    "Date Range": {
      label: "Date Range",
      type: "date",
      required: false,
      searchKey: {
        start: "start_date",
        end: "end_date",
      },
    },
  };

  const renderTopRightContent = ({ searchParams, loading }: any) => {
    const startDate = searchParams?.get("start_date");
    const endDate = searchParams?.get("end_date");

    if (loading) {
      return <div className="h-5 w-48 animate-pulse bg-gray-200 rounded-sm"></div>;
    }

    if (startDate && endDate) {
      return (
        <p className="text-[16px] font-medium text-primary_text">
          From <span className="text-[24px] font-semibold text-p_primary">{formatDateToDDMMYYYY(startDate)}</span>{" "}
          To <span className="text-[24px] font-semibold text-p_primary">{formatDateToDDMMYYYY(endDate)}</span>
        </p>
      );
    }

    return (
      <p className="text-[16px] font-medium text-primary_text">
        As on <span className="text-[24px] font-semibold text-p_primary">{formatDateToDDMMYYYY(new Date().toISOString())}</span>
      </p>
    );
  };

  return (
    <div>
      <Breadcrumbs
        navPath={["Zoodpay Money", "Journal Voucher"]}
        heading="Journal Voucher"
        noNavigation={true}
        list={true}
        button={{
          buttonName: "Add Manual",
          className: "px-4 whitespace-nowrap",
          buttonOnclick: () => {
            navigate("/zoodpay-money/journal-voucher/add-manual-entries");
          },
        }}
      />
      <GridTable
        staticText={staticText}
        mainEndPoint={journalVoucher}
        TableDetails={TableDetails}
        params={{ page_number: "1", client_timezone: clientTimezone }}
        searchPlaceholder="Search by transaction id"
        filters={true}
        exporting={true}
        notfoundRoute={{ state: { route: `/zoodpay-money/journal-voucher` } }}
        title="Journal Voucher"
        hasViewMDPrivilege={true}
        addMorePadding={false}
        filterShimmer={true}
        dynamicFilterConfig={dynamicFilterConfig}
        customHeight="h-[103px]"
        forceFullWidth={true}
        listTitle="List of Journal Voucher"
        renderTopRightContent={renderTopRightContent}
        reportType="Journal Voucher"
        mainDivScroll={true}
      />
    </div>
  );
}

